import React, { useState, useEffect, useRef } from 'react';
import { useLang } from '../../i18n/LanguageContext';
import { Link } from 'react-router-dom';
import { FaArrowRight, FaTiktok, FaFacebookF, FaLinkedinIn, FaGoogle, FaStar, FaPlay } from 'react-icons/fa';

// ── Live ticker feed ──────────────────────────────────────────────
const TICKER_ITEMS = [
  { icon: '⏸', text: 'Campagne mise en pause — CPA au-dessus de 12 €', platform: 'Meta',     color: '#60a5fa', time: 'il y a 2 s' },
  { icon: '🚀', text: 'Nouvelle campagne lancée sur TikTok',            platform: 'TikTok',   color: '#fb7185', time: 'il y a 14 s' },
  { icon: '🎬', text: 'Vidéo générée dans Cinema Studio',               platform: 'Studio',   color: '#c4b5fd', time: 'il y a 31 s' },
  { icon: '📈', text: 'CTR en hausse à 4,2 % cette semaine',            platform: 'LinkedIn', color: '#7dd3fc', time: 'il y a 1 min' },
  { icon: '🛍️', text: 'Catalogue Shopify analysé — 24 produits',        platform: 'Shopify',  color: '#a3e635', time: 'il y a 2 min' },
  { icon: '💬', text: 'Alex a terminé l’audit de vos comptes',          platform: 'Alex IA',  color: '#5eead4', time: 'il y a 3 min' },
];

const PLATFORMS = ['TikTok Ads', 'Meta Ads', 'LinkedIn Ads', 'Snapchat Ads', 'Google Ads'];

const LOGOS = [
  { icon: <FaTiktok />, name: 'TikTok' }, { icon: <FaFacebookF />, name: 'Meta' },
  { icon: <FaLinkedinIn />, name: 'LinkedIn' }, { icon: <FaGoogle />, name: 'Google' },
  { icon: '👻', name: 'Snapchat' }, { icon: '🛍️', name: 'Shopify' },
];

const FEATURE_CHIPS = [
  { icon: '💬', key: 'landing.hero.chipAlex' },
  { icon: '🎬', key: 'landing.hero.chipStudio' },
  { icon: '🛍️', key: 'landing.hero.chipShopify' },
  { icon: '🎯', key: 'landing.hero.chipPixel' },
  { icon: '📊', key: 'landing.hero.chipPlan' },
  { icon: '🕘', key: 'landing.hero.chipHistory' },
];

// ── Panneau produit — Campaign Manager ────────────────────────────
const MOCK_CAMPAIGNS = [
  { name: 'Soldes d’été — Installations', platform: 'TikTok',   status: 'ACTIVE', spend: '892 €', trend: '+12 %', up: true },
  { name: 'Acquisition — Maroc T2',       platform: 'Meta',     status: 'ACTIVE', spend: '312 €', trend: '+7 %',  up: true },
  { name: 'Décideurs B2B',                platform: 'LinkedIn', status: 'PAUSE',  spend: '0 €',   trend: '—',     up: false },
];

function MiniDashboard() {
  const [active, setActive] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setActive(a => (a + 1) % MOCK_CAMPAIGNS.length), 2400);
    return () => clearInterval(t);
  }, []);

  return (
    <div className="glass-panel" style={{ width: '100%', maxWidth: 520 }}>
      <div style={{ padding: '13px 18px', borderBottom: '1px solid rgba(255,255,255,0.07)', display: 'flex', alignItems: 'center', justifyContent: 'space-between', background: 'rgba(255,255,255,0.025)' }}>
        <div style={{ display: 'flex', gap: 6 }}>
          {['#ff5f57', '#febc2e', '#28c840'].map(c => (
            <div key={c} style={{ width: 9, height: 9, borderRadius: '50%', background: c }} />
          ))}
        </div>
        <span style={{ fontSize: 10.5, color: 'rgba(255,255,255,0.42)', fontWeight: 600, letterSpacing: '.02em' }}>Campaign Manager · OneBotAds</span>
        <div className="live-dot" />
      </div>

      <div style={{ display: 'flex', gap: 5, padding: '11px 16px', borderBottom: '1px solid rgba(255,255,255,0.05)', overflowX: 'auto' }}>
        {['TikTok', 'Meta', 'LinkedIn', 'Snapchat'].map((p, i) => (
          <span key={p} style={{
            padding: '4px 12px', borderRadius: 7, fontSize: 10.5, fontWeight: 600, whiteSpace: 'nowrap', flexShrink: 0,
            background: i === 0 ? 'rgba(109,93,251,0.22)' : 'rgba(255,255,255,0.04)',
            border: i === 0 ? '1px solid rgba(109,93,251,0.55)' : '1px solid rgba(255,255,255,0.06)',
            color: i === 0 ? '#c7bfff' : 'rgba(255,255,255,0.35)',
          }}>{p}</span>
        ))}
      </div>

      <div style={{ display: 'flex', borderBottom: '1px solid rgba(255,255,255,0.05)' }}>
        {[{ l: 'Dépense', v: '1 204 €', c: '#c4b5fd' }, { l: 'Impressions', v: '781 K', c: '#7dd3fc' }, { l: 'CTR moyen', v: '3,5 %', c: '#5eead4' }].map((s, i) => (
          <div key={i} style={{ flex: 1, padding: '13px 16px', borderRight: i < 2 ? '1px solid rgba(255,255,255,0.05)' : 'none' }}>
            <div style={{ fontSize: 9.5, color: 'rgba(255,255,255,0.34)', textTransform: 'uppercase', letterSpacing: '.1em', marginBottom: 5 }}>{s.l}</div>
            <div style={{ fontSize: 19, fontWeight: 800, color: s.c, letterSpacing: '-.02em', fontVariantNumeric: 'tabular-nums' }}>{s.v}</div>
          </div>
        ))}
      </div>

      <div style={{ padding: '6px 0' }}>
        {MOCK_CAMPAIGNS.map((c, i) => (
          <div key={i} style={{
            display: 'flex', alignItems: 'center', gap: 10, padding: '11px 16px',
            background: active === i ? 'rgba(109,93,251,0.12)' : 'transparent',
            borderLeft: active === i ? '2px solid #6D5DFB' : '2px solid transparent',
            transition: 'all .45s cubic-bezier(.4,0,.2,1)',
          }}>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ fontSize: 12, fontWeight: 600, color: active === i ? '#fff' : 'rgba(255,255,255,0.62)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{c.name}</div>
              <div style={{ fontSize: 9.5, color: 'rgba(255,255,255,0.28)', marginTop: 2 }}>{c.platform}</div>
            </div>
            <span style={{
              padding: '2px 8px', borderRadius: 999, fontSize: 9, fontWeight: 800, letterSpacing: '.05em', flexShrink: 0,
              background: c.status === 'ACTIVE' ? 'rgba(94,234,212,0.13)' : 'rgba(251,191,36,0.11)',
              color: c.status === 'ACTIVE' ? '#5eead4' : '#fbbf24',
              border: c.status === 'ACTIVE' ? '1px solid rgba(94,234,212,0.28)' : '1px solid rgba(251,191,36,0.22)',
            }}>{c.status}</span>
            <div style={{ textAlign: 'right', flexShrink: 0, minWidth: 58 }}>
              <div style={{ fontSize: 12, fontWeight: 700, color: '#fff', fontVariantNumeric: 'tabular-nums' }}>{c.spend}</div>
              <div style={{ fontSize: 9.5, color: c.up ? '#5eead4' : 'rgba(255,255,255,0.28)' }}>{c.trend}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

function LiveTicker() {
  const [items, setItems] = useState(TICKER_ITEMS.slice(0, 3));
  useEffect(() => {
    let idx = 3;
    const t = setInterval(() => {
      const next = TICKER_ITEMS[idx % TICKER_ITEMS.length];
      setTimeout(() => setItems(prev => [next, ...prev.slice(0, 2)]), 320);
      idx++;
    }, 3200);
    return () => clearInterval(t);
  }, []);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 7, width: '100%', maxWidth: 340 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 7, marginBottom: 2 }}>
        <div className="live-dot" />
        <span style={{ fontSize: 10, fontWeight: 800, color: '#5eead4', textTransform: 'uppercase', letterSpacing: '.16em' }}>Activité en direct</span>
      </div>
      {items.map((item, i) => (
        <div key={`${item.text}-${i}`} className="glass-panel" style={{
          display: 'flex', alignItems: 'flex-start', gap: 10, padding: '10px 13px',
          opacity: i === 0 ? 1 : 0.55 - i * 0.12,
          transform: `scale(${1 - i * 0.025})`,
          transition: 'all .4s cubic-bezier(.4,0,.2,1)',
        }}>
          <span style={{ fontSize: 13, flexShrink: 0, lineHeight: 1.4 }}>{item.icon}</span>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontSize: 11.5, color: 'rgba(255,255,255,0.78)', lineHeight: 1.45 }}>{item.text}</div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginTop: 3 }}>
              <span style={{ fontSize: 9.5, fontWeight: 800, color: item.color, letterSpacing: '.03em' }}>{item.platform}</span>
              <span style={{ fontSize: 9.5, color: 'rgba(255,255,255,0.24)' }}>· {item.time}</span>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

function useCounter(target, duration = 1700, active = false) {
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (!active) return;
    let raf, start = null;
    const step = (ts) => {
      if (!start) start = ts;
      const p = Math.min((ts - start) / duration, 1);
      const eased = 1 - Math.pow(1 - p, 3);
      setCount(Math.floor(eased * target));
      if (p < 1) raf = requestAnimationFrame(step);
    };
    raf = requestAnimationFrame(step);
    return () => cancelAnimationFrame(raf);
  }, [target, duration, active]);
  return count;
}

// ── Hero ──────────────────────────────────────────────────────────
const Hero = () => {
  const { t } = useLang();
  const [pidx, setPidx]       = useState(0);
  const [fade, setFade]       = useState(true);
  const [statsOn, setStatsOn] = useState(false);
  const statsRef              = useRef(null);

  useEffect(() => {
    const id = setInterval(() => {
      setFade(false);
      setTimeout(() => { setPidx(i => (i + 1) % PLATFORMS.length); setFade(true); }, 300);
    }, 2800);
    return () => clearInterval(id);
  }, []);

  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => { if (e.isIntersecting) setStatsOn(true); }, { threshold: 0.3 });
    if (statsRef.current) obs.observe(statsRef.current);
    return () => obs.disconnect();
  }, []);

  const c1 = useCounter(9000, 1700, statsOn);
  const c2 = useCounter(5,    1700, statsOn);
  const c3 = useCounter(98,   1700, statsOn);

  return (
    <>
      <style>{`
        /* ── Fond : aurores lentes + grain, le tout en CSS pur ── */
        @keyframes auroraA { 0%,100%{transform:translate3d(-6%,-4%,0) scale(1)} 50%{transform:translate3d(8%,6%,0) scale(1.18)} }
        @keyframes auroraB { 0%,100%{transform:translate3d(6%,4%,0) scale(1.1)} 50%{transform:translate3d(-8%,-6%,0) scale(.92)} }
        @keyframes auroraC { 0%,100%{transform:translate3d(0,0,0) scale(.95)} 50%{transform:translate3d(-5%,8%,0) scale(1.22)} }
        @keyframes marquee  { from{transform:translateX(0)} to{transform:translateX(-50%)} }
        @keyframes riseIn   { from{opacity:0;transform:translateY(28px)} to{opacity:1;transform:translateY(0)} }
        @keyframes floatY   { 0%,100%{transform:translateY(0)} 50%{transform:translateY(-10px)} }
        @keyframes pulseDot { 0%,100%{opacity:1;box-shadow:0 0 0 0 rgba(94,234,212,.55)} 70%{opacity:.85;box-shadow:0 0 0 7px rgba(94,234,212,0)} }
        @keyframes sheen    { from{background-position:-220% 0} to{background-position:220% 0} }

        .aurora{position:absolute;border-radius:50%;filter:blur(90px);pointer-events:none;will-change:transform}
        .live-dot{width:7px;height:7px;border-radius:50%;background:#5eead4;animation:pulseDot 2.2s ease-out infinite;flex-shrink:0}

        .glass-panel{
          background:linear-gradient(160deg, rgba(23,19,58,.88), rgba(12,9,34,.94));
          border:1px solid rgba(255,255,255,.09);
          border-radius:16px; overflow:hidden;
          box-shadow:0 30px 70px -20px rgba(0,0,0,.7), 0 0 0 1px rgba(255,255,255,.02) inset;
          backdrop-filter:blur(10px); -webkit-backdrop-filter:blur(10px);
        }

        .hero-rise > *{animation:riseIn .8s cubic-bezier(.16,1,.3,1) both}
        .hero-rise > *:nth-child(1){animation-delay:.05s}
        .hero-rise > *:nth-child(2){animation-delay:.14s}
        .hero-rise > *:nth-child(3){animation-delay:.23s}
        .hero-rise > *:nth-child(4){animation-delay:.32s}
        .hero-rise > *:nth-child(5){animation-delay:.41s}
        .hero-rise > *:nth-child(6){animation-delay:.5s}
        .hero-visual{animation:riseIn 1s cubic-bezier(.16,1,.3,1) .3s both}
        .hero-float{animation:floatY 6.5s ease-in-out infinite}

        /* Mot de plateforme : bascule verticale nette, pas un simple fondu */
        .pf{display:inline-block;transition:opacity .3s ease, transform .3s cubic-bezier(.16,1,.3,1)}
        .pf.out{opacity:0;transform:translateY(-14px) skewY(-3deg)}
        .pf.in{opacity:1;transform:translateY(0) skewY(0)}

        .cta-main{
          position:relative;overflow:hidden;
          background:linear-gradient(135deg,#6D5DFB,#4F46E5 55%,#3B82F6);
          box-shadow:0 10px 34px -6px rgba(109,93,251,.6), 0 0 0 1px rgba(255,255,255,.12) inset;
          transition:transform .22s cubic-bezier(.16,1,.3,1), box-shadow .22s ease;
        }
        .cta-main::after{
          content:'';position:absolute;inset:0;
          background:linear-gradient(100deg,transparent 35%,rgba(255,255,255,.35) 50%,transparent 65%);
          background-size:220% 100%;animation:sheen 3.4s ease-in-out infinite;
        }
        .cta-main:hover{transform:translateY(-3px);box-shadow:0 18px 46px -8px rgba(109,93,251,.75), 0 0 0 1px rgba(255,255,255,.2) inset}
        .cta-ghost2{transition:all .22s cubic-bezier(.16,1,.3,1)}
        .cta-ghost2:hover{background:rgba(255,255,255,.11)!important;border-color:rgba(255,255,255,.42)!important;transform:translateY(-3px)}

        .chip2{transition:all .22s ease}
        .chip2:hover{background:rgba(255,255,255,.11)!important;border-color:rgba(255,255,255,.28)!important;transform:translateY(-2px)}

        .marquee-track{display:flex;gap:14px;width:max-content;animation:marquee 34s linear infinite}
        .marquee-mask{
          overflow:hidden;
          -webkit-mask-image:linear-gradient(90deg,transparent,#000 9%,#000 91%,transparent);
          mask-image:linear-gradient(90deg,transparent,#000 9%,#000 91%,transparent);
        }
        .marquee-track:hover{animation-play-state:paused}
        .logo-pill2{
          display:flex;align-items:center;gap:9px;padding:11px 20px;border-radius:12px;flex-shrink:0;
          background:rgba(255,255,255,.045);border:1px solid rgba(255,255,255,.09);
          color:rgba(255,255,255,.82);font-size:14px;font-weight:600;white-space:nowrap;
          transition:all .22s ease;
        }
        .logo-pill2:hover{background:rgba(255,255,255,.1);border-color:rgba(255,255,255,.22);transform:translateY(-2px)}

        .stat-num{
          font-size:clamp(30px,4.4vw,44px);font-weight:900;letter-spacing:-.035em;line-height:1;
          background:linear-gradient(135deg,#fff 20%,#b9b1ff);
          -webkit-background-clip:text;background-clip:text;-webkit-text-fill-color:transparent;
          font-variant-numeric:tabular-nums;
        }

        @media (max-width:900px){
          .hero-grid{grid-template-columns:1fr!important;gap:44px!important}
          .hero-visual{align-items:center!important}
          .hero-br{display:none}
        }
        @media (prefers-reduced-motion:reduce){
          .aurora,.hero-float,.cta-main::after,.marquee-track,.live-dot{animation:none!important}
          .hero-rise > *,.hero-visual{animation:none!important;opacity:1!important;transform:none!important}
        }
      `}</style>

      <section id="home" style={{
        position: 'relative', overflow: 'hidden', paddingTop: 64,
        background: 'radial-gradient(140% 100% at 50% 0%, #191345 0%, #0C0926 45%, #06041A 100%)',
      }}>
        {/* Aurores */}
        <div className="aurora" style={{ top: '-22%', left: '-14%', width: 720, height: 720, background: 'radial-gradient(circle, rgba(109,93,251,.5) 0%, transparent 68%)', animation: 'auroraA 19s ease-in-out infinite' }} />
        <div className="aurora" style={{ top: '4%', right: '-18%', width: 640, height: 640, background: 'radial-gradient(circle, rgba(56,189,248,.32) 0%, transparent 68%)', animation: 'auroraB 23s ease-in-out infinite' }} />
        <div className="aurora" style={{ bottom: '-26%', left: '26%', width: 600, height: 600, background: 'radial-gradient(circle, rgba(217,70,239,.26) 0%, transparent 68%)', animation: 'auroraC 27s ease-in-out infinite' }} />

        {/* Grille technique + grain : donne la matière « produit », pas « template » */}
        <div style={{
          position: 'absolute', inset: 0, pointerEvents: 'none', opacity: .5,
          backgroundImage: 'linear-gradient(rgba(255,255,255,.028) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,.028) 1px, transparent 1px)',
          backgroundSize: '72px 72px',
          WebkitMaskImage: 'radial-gradient(85% 65% at 50% 32%, #000 0%, transparent 100%)',
          maskImage: 'radial-gradient(85% 65% at 50% 32%, #000 0%, transparent 100%)',
        }} />

        <div className="hero-grid" style={{
          position: 'relative', zIndex: 1, maxWidth: 1240, margin: '0 auto',
          padding: '84px 24px 0', display: 'grid',
          gridTemplateColumns: '1.05fr .95fr', gap: 56, alignItems: 'center',
        }}>

          {/* ─ Colonne texte ─ */}
          <div className="hero-rise">
            {/* Badge de confiance */}
            <div style={{
              display: 'inline-flex', alignItems: 'center', flexWrap: 'wrap', maxWidth: '100%',
              gap: 9, rowGap: 5, marginBottom: 28, padding: '8px 15px', borderRadius: 999,
              border: '1px solid rgba(253,230,138,.28)', background: 'rgba(253,230,138,.07)',
              backdropFilter: 'blur(8px)',
            }}>
              <div style={{ display: 'flex', gap: 1.5 }}>
                {[1, 2, 3, 4, 5].map(i => <FaStar key={i} style={{ fontSize: 10, color: '#FCD34D' }} />)}
              </div>
              <span style={{ fontSize: 12, color: '#FDE68A', fontWeight: 800, letterSpacing: '.02em' }}>{t('landing.hero.ratingBadge')}</span>
              <span style={{ width: 1, height: 12, background: 'rgba(255,255,255,.2)' }} />
              <span style={{ fontSize: 12, color: 'rgba(255,255,255,.7)' }}>{t('landing.hero.trustBadge')}</span>
            </div>

            {/* Titre — c'est lui qui doit frapper */}
            <h1 style={{
              fontSize: 'clamp(38px,6.4vw,74px)', fontWeight: 900, lineHeight: 1.02,
              letterSpacing: '-.045em', color: '#fff', marginBottom: 22,
              textWrap: 'balance', textShadow: '0 4px 40px rgba(0,0,0,.5)',
            }}>
              {t('landing.hero.titleLine1')}
              <br className="hero-br" />
              <span className={`pf ${fade ? 'in' : 'out'}`} style={{
                background: 'linear-gradient(120deg,#a78bfa 0%,#818cf8 40%,#38bdf8 100%)',
                WebkitBackgroundClip: 'text', backgroundClip: 'text', WebkitTextFillColor: 'transparent',
              }}>{PLATFORMS[pidx]}</span>{' '}
              <span style={{ color: 'rgba(255,255,255,.5)' }}>{t('landing.hero.titleSuffix')}</span>
            </h1>

            {/* Sous-titre */}
            <p style={{
              fontSize: 17.5, color: 'rgba(255,255,255,.66)', lineHeight: 1.72,
              marginBottom: 26, maxWidth: '54ch',
            }}>{t('landing.hero.sub')}</p>

            {/* Capacités */}
            <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 34 }}>
              {FEATURE_CHIPS.map(f => (
                <span key={f.key} className="chip2" style={{
                  display: 'inline-flex', alignItems: 'center', gap: 7, padding: '8px 14px',
                  borderRadius: 999, background: 'rgba(255,255,255,.055)',
                  border: '1px solid rgba(255,255,255,.13)', backdropFilter: 'blur(8px)',
                  fontSize: 12.5, fontWeight: 600, color: 'rgba(255,255,255,.86)',
                }}>
                  <span style={{ fontSize: 13.5 }}>{f.icon}</span> {t(f.key)}
                </span>
              ))}
            </div>

            {/* Actions */}
            <div style={{ display: 'flex', gap: 13, flexWrap: 'wrap', marginBottom: 46 }}>
              <Link to="/signup" className="cta-main" style={{
                display: 'inline-flex', alignItems: 'center', gap: 9, padding: '16px 32px',
                borderRadius: 13, color: '#fff', fontWeight: 700, fontSize: 15.5, textDecoration: 'none',
              }}>
                <span style={{ position: 'relative', zIndex: 1, display: 'inline-flex', alignItems: 'center', gap: 9 }}>
                  {t('landing.hero.ctaPrimary')} <FaArrowRight style={{ fontSize: 12 }} />
                </span>
              </Link>
              <Link to="/shopify" className="cta-ghost2" style={{
                display: 'inline-flex', alignItems: 'center', gap: 9, padding: '16px 30px',
                borderRadius: 13, background: 'rgba(255,255,255,.055)',
                border: '1.5px solid rgba(255,255,255,.2)', color: '#fff',
                fontWeight: 600, fontSize: 15, textDecoration: 'none', backdropFilter: 'blur(8px)',
              }}>🛍️ {t('landing.hero.ctaMerchant')}</Link>
              <Link to="/login" className="cta-ghost2" style={{
                display: 'inline-flex', alignItems: 'center', gap: 8, padding: '16px 26px',
                borderRadius: 13, background: 'transparent',
                border: '1.5px solid rgba(255,255,255,.13)', color: 'rgba(255,255,255,.75)',
                fontWeight: 600, fontSize: 15, textDecoration: 'none',
              }}><FaPlay style={{ fontSize: 9 }} /> {t('landing.hero.ctaDemo')}</Link>
            </div>

            {/* Chiffres */}
            <div ref={statsRef} style={{ display: 'flex', gap: 40, flexWrap: 'wrap' }}>
              {[
                { val: c1.toLocaleString('fr-FR') + '+', label: t('landing.hero.statMerchants') },
                { val: c2 + '+', label: t('landing.hero.statPlatforms') },
                { val: c3 + ' %', label: t('landing.hero.statSatisfaction') },
              ].map((s, i) => (
                <div key={i}>
                  <div className="stat-num">{s.val}</div>
                  <div style={{
                    fontSize: 11, color: 'rgba(255,255,255,.42)', marginTop: 8,
                    textTransform: 'uppercase', letterSpacing: '.12em', fontWeight: 600,
                  }}>{s.label}</div>
                </div>
              ))}
            </div>
          </div>

          {/* ─ Colonne produit ─ */}
          <div className="hero-visual" style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 18 }}>
            <div className="hero-float"><MiniDashboard /></div>
            <LiveTicker />
          </div>
        </div>

        {/* ── Bandeau plateformes ── */}
        <div style={{ position: 'relative', zIndex: 1, marginTop: 84, paddingBottom: 54 }}>
          <div style={{ height: 1, background: 'linear-gradient(90deg,transparent,rgba(255,255,255,.14),transparent)', marginBottom: 30 }} />
          <p style={{
            textAlign: 'center', fontSize: 10.5, textTransform: 'uppercase', letterSpacing: '.22em',
            color: 'rgba(255,255,255,.34)', fontWeight: 700, marginBottom: 26,
          }}>{t('landing.hero.marquee')}</p>
          <div className="marquee-mask">
            <div className="marquee-track">
              {[...LOGOS, ...LOGOS, ...LOGOS].map((l, i) => (
                <div key={i} className="logo-pill2">
                  <span style={{ fontSize: 17, display: 'flex', alignItems: 'center' }}>{l.icon}</span>
                  {l.name}
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Hero;
